import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'COMMENTARY',
  inside: {
    match: { get: 'commentaries', set: 'commentary' },
  },
});
